import angular from 'angular';

var SECURITY_HIDDEN_CLASS = 'no-access';

angular.module('cloudX').directive('cxSecurity', [
  '$rootScope',
  'checkSecurity',
  function($rootScope, checkSecurity) {
    return {
      restrict: 'A',
      link: function(scope, element, attr) {
        var security = {};
        var doCheck = function() {
          if (checkSecurity(security)) element.removeClass(SECURITY_HIDDEN_CLASS);
          else element.addClass(SECURITY_HIDDEN_CLASS);
        };

        scope.$watch(attr.cxSecurity, function(value) {
          security = checkSecurity.parse(value);
          doCheck();
        });

        var destroyer = $rootScope.$on('$cxAuthenticated', function() {
          doCheck();
        });
        scope.$on('$destroy', function() {
          destroyer();
        });
      },
    };
  },
]);
